import { FaBullhorn, FaChartLine, FaUsers, FaSmileBeam, FaShieldAlt, FaSearch, FaVideo, FaShareAlt } from "react-icons/fa";

export const services = [
  {
    id: 1,
    slug: "content-creation",
    title: "Content Creation",
    icon: FaBullhorn,
    short:
      "High-performing content systems designed to attract, educate, and convert your best-fit audience.",
    hero: "Create content that builds authority and demand.",
    overview:
      "We craft content ecosystems that align with your brand voice, funnel stage, and growth goals. From strategy to production, we build content your audience actually wants to share.",
    benefits: [
      "Consistent brand voice and messaging",
      "Audience-first storytelling",
      "Improved organic reach and engagement",
      "Content mapped to your sales funnel"
    ],
    process: [
      "Audience and competitor analysis",
      "Content pillars and creative direction",
      "Production, editing, and publishing cadence",
      "Performance review and optimization"
    ]
  },
  {
    id: 2,
    slug: "targeted-digital-ads",
    title: "Targeted Digital Ads",
    icon: FaChartLine,
    short:
      "Data-driven ads engineered to acquire qualified leads, lower CAC, and scale profitable campaigns.",
    hero: "Precision campaigns with measurable ROI.",
    overview:
      "We build and optimize high-converting ad campaigns across search, social, and display channels with a relentless focus on performance.",
    benefits: [
      "Laser-focused audience targeting",
      "Conversion-led creative testing",
      "Real-time optimization",
      "Transparent reporting"
    ],
    process: [
      "Campaign architecture and tracking",
      "Creative and offer development",
      "Launch, test, and iterate",
      "Scale winning ad sets"
    ]
  },
  {
    id: 3,
    slug: "influencer-marketing",
    title: "Influencer Marketing",
    icon: FaUsers,
    short:
      "Authentic creator partnerships that amplify trust, accelerate awareness, and boost conversions.",
    hero: "Creators that align with your brand story.",
    overview:
      "We source, vet, and manage influencer partnerships that generate credibility and measurable business results.",
    benefits: [
      "Brand-safe creator curation",
      "Performance-based collaborations",
      "Multi-platform amplification",
      "Trackable conversions"
    ],
    process: [
      "Influencer discovery and outreach",
      "Campaign planning and briefing",
      "Content approval and launch",
      "Performance insights and scaling"
    ]
  },
  {
    id: 4,
    slug: "meme-marketing",
    title: "Meme Marketing",
    icon: FaSmileBeam,
    short:
      "Culture-led memes and social content that spark conversations and keep your brand top-of-mind.",
    hero: "Stay relevant with culture-first creativity.",
    overview:
      "Our team crafts meme-driven campaigns that feel organic, shareable, and aligned with your brand tone.",
    benefits: [
      "Increase social shareability",
      "Tap into trending conversations",
      "Humanize your brand voice",
      "Drive viral engagement"
    ],
    process: [
      "Trend monitoring and ideation",
      "Creative execution and approvals",
      "Publishing and community engagement",
      "Weekly trend + results review"
    ]
  },
  {
    id: 5,
    slug: "orm",
    title: "ORM (Online Reputation Management)",
    icon: FaShieldAlt,
    short:
      "Protect and strengthen your digital reputation with proactive monitoring and response strategy.",
    hero: "Build unshakeable trust online.",
    overview:
      "We monitor, respond, and elevate your online reputation with a multi-channel strategy that builds trust and authority.",
    benefits: [
      "Review management workflows",
      "Brand sentiment tracking",
      "Crisis response planning",
      "Authority content to outrank negatives"
    ],
    process: [
      "Reputation audit",
      "Monitoring setup",
      "Response and escalation workflows",
      "Reputation growth plan"
    ]
  },
  {
    id: 6,
    slug: "market-research",
    title: "Market Research & Surveys",
    icon: FaSearch,
    short:
      "Research-led insights that reveal what your market wants and how to win demand.",
    hero: "Make decisions powered by real insight.",
    overview:
      "We design and run surveys, interviews, and competitive analysis that give you clarity on market fit and positioning.",
    benefits: [
      "Validated audience insights",
      "Sharper positioning",
      "Competitive differentiation",
      "Actionable next steps"
    ],
    process: [
      "Research plan and hypotheses",
      "Survey design and deployment",
      "Insight synthesis",
      "Go-to-market recommendations"
    ]
  },
  {
    id: 7,
    slug: "video-editing",
    title: "Video Editing",
    icon: FaVideo,
    short:
      "Cinematic, scroll-stopping video edits optimized for every platform and audience segment.",
    hero: "Video that drives attention and action.",
    overview:
      "From short-form reels to long-form brand stories, our editors turn raw footage into performance-ready assets.",
    benefits: [
      "Platform-optimized formats",
      "High retention storytelling",
      "Consistent visual style",
      "Fast turnaround"
    ],
    process: [
      "Creative brief and storyboards",
      "Editing and motion graphics",
      "Sound design and color grading",
      "Delivery and iteration"
    ]
  },
  {
    id: 8,
    slug: "multiplatform-management",
    title: "Multiplatform Management",
    icon: FaShareAlt,
    short:
      "End-to-end channel management across social platforms with consistent growth and engagement.",
    hero: "One strategy. Every platform. All aligned.",
    overview:
      "We unify your social presence with a consistent content strategy, publishing schedule, and performance loop.",
    benefits: [
      "Unified brand presence",
      "Consistent publishing cadence",
      "Community engagement systems",
      "Analytics-driven optimization"
    ],
    process: [
      "Channel audit",
      "Editorial calendar",
      "Publishing and community management",
      "Monthly performance roadmap"
    ]
  }
];

export const serviceSteps = [
  "Discovery and brand immersion",
  "Strategy, positioning, and messaging",
  "Creative production and campaign builds",
  "Launch, optimization, and scaling",
  "Reporting, insights, and next-growth roadmap"
];